import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

type SuggestionsListWrapperProps = {
  $minHeight: number
}

export const SuggestionsListWrapper = styled.div<SuggestionsListWrapperProps>`
  position: absolute;
  bottom: calc(100% + ${toRem(5)});
  width: 100%;
  border: ${toRem(2)} solid var(--input-primary-border-color-default);
  min-height: ${props => toRem(props.$minHeight || 100)};
  max-height: ${props => toRem(props.$minHeight*2 || 200)};
  background-color: ${COLORS.BG.PAGE};
  border-radius: var(--input-l-border-radius);
  overflow: auto;
`

export const SuggestionsListButton = styled.button`
  padding: ${toRem(8)} ${toRem(10)};
  width: 100%;
  text-align: left;

  @media (any-hover: hover){
    &:hover{
      background-color: ${COLORS.BG.SURFACE2};
    }
  }
`